import React from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Excelldownload = ({ data }) => {
  return (
    <ExcelFile 
      element={<Button type="ghost" style={{ width: "100%", backgroundColor: "green", color: "white" }}>Download Excel</Button>}
    >
      <ExcelSheet data={data} name="Dispatched Orders">
        <ExcelColumn label="Invoice No" value="invoice_number" />
        <ExcelColumn label="Dispatch Date" value="dispatch_date" />
        <ExcelColumn label="Location" value="location_name" />
        <ExcelColumn label="Courier" value="delivery_type_name" />
        <ExcelColumn label="Customer" value="contact_name" />
        <ExcelColumn label="Phone" value="contact_phone" />
        <ExcelColumn label="Payment" value="payment" />
        <ExcelColumn label="Due" value="due" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;
